import { CloseButton, Drawer, Image } from "@chakra-ui/react";
import { useCallback } from "react";
import { HeaderMenuContent } from "./headerMenuContent";
import Logo from "./assets/logo-novel.svg";

type Props = {
  isOpen: boolean;
  onClose?: () => void;
};

export const DrawerMenu = ({ isOpen, onClose }: Props) => {
  const handleOnOpenChange = useCallback(
    ({ open }: { open: boolean }) => {
      if (!open) {
        onClose?.();
      }
    },
    [onClose],
  );

  return (
    <Drawer.Root open={isOpen} onOpenChange={handleOnOpenChange}>
      <Drawer.Backdrop />
      <Drawer.Positioner
        padding={{
          base: "0",
          lg: "4",
        }}
      >
        <Drawer.Content
          bg="backgroundPrimary"
          overflow="hidden"
          rounded={{
            base: "0",
            lg: "md",
          }}
        >
          <Drawer.Header bg="backgroundPrimary">
            <Image alt="Teller Novel" src={Logo} w="140px" />
            <Drawer.CloseTrigger asChild>
              <CloseButton size="md" color="contentPrimary" />
            </Drawer.CloseTrigger>
          </Drawer.Header>
          <HeaderMenuContent h="100%" />
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
};
